export const MEMBERSHIP_DISCOUNT_MULTIPLIER = 0.85
export const MEMBERSHIP_DISCOUNT_CATEGORIES = ['bundle', 'supplement']
